<template>
  <div>
    <div class="admin-header">
      <div class="container">
        <div class="row">
        <div class="col-lg-12">
          <h1 class="white">Create Product</h1>
        </div>
        </div>
      </div>
    </div>
   <div class="container" v-if="processing">
          <div class="row space-loader d-flex align-items-center justify-content-center">
            <b-spinner style="width: 6rem; height: 6rem;" label="Large Spinner"></b-spinner>
          </div>
        </div>
    <ProductForm v-else v-on:submitted="createProduct" />
    
  </div>
</template>

<script>
import api from "../../api/api";
import ProductForm from '@/components/Admin/ProductForm.vue'; 
export default {
  components: {
    ProductForm,
  },
  data: function () {
    return {
      processing: false,
    };
  },

  methods: {
    createProduct(data) {
      this.processing = true; 
      api.createProduct(data)
      .then(() => {
        this.$router.push("/admin/products");
      // }).catch(err => {
      //   console.log(err);
      // }).finally(() => {
        this.processing = false;
      });
    }
  }
  
};
</script>